import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { FeatureContext } from '../../context api/Features/FeatureContext'

import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success, getNewToken } from '../../shared/constants'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'

export const useCustomer = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [customer, setCustomer] = useState(false)
  const history = useHistory()
  const { addNewCustomer, editNewCustomer, deleteNewCustomer, getNewCustomers } = useContext(FeatureContext)
  const [loading, setLoading] = useState(false)
  const [cancelToken, setCancelToken] = useState()
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [paginate, setPaginate] = useState({})

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  //CUSTOMER
  const getAllCustomer = (dto = {}) => {
    axios
      .get(API.GET_ALL_CUSTOMERS(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        getNewCustomers(data.data ? data.data : [])
        setPaginate(data.paginate)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getCustomer = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_CUSTOMER, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setCustomer(data.data)
      })
      .catch((err) => {
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addCustomer = async (data) => {
    setLoading(true)
    console.log(data)
    if(data.pincode.length != 6) return toastMessage('Pincode should be 6 digits', error)
    if(data.gstNumber && data.gstNumber.length != 15) return toastMessage('GST Number should be 15 digits', error)
    axios
      .post(API.ADD_CUSTOMER, data, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Customer Added Successfully', success)

        history.push(ROUTES.CUSTOMERS)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const updateCustomer = async (data) => {
    setLoading(true)
    console.log(data)
    if(data.pincode.length != 6) return toastMessage('Pincode should be 6 digits', error)
    if(data.gstNumber && data.gstNumber.length != 6) return toastMessage('GST Number should be 6 digits', error)
    axios
      .put(API.EDIT_CUSTOMER, data, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Customer Updated Successfully', success)
        getAllCustomer()
        return history.push(ROUTES.CUSTOMERS)

        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteCustomer = async (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_CUSTOMER, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Customer Deleted Successfully', success)
        //console.log(dto)
        deleteNewCustomer(dto.customerId)
        setSelected([])
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteManyCustomer = async (dto, setSelected) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .post(API.DELETE_MANY_CUSTOMER, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.customerId.length} Customer Deleted Successfully`, success)

        dto.customerId.map((item) => deleteNewCustomer(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewCustomer)
        return getAllCustomer()
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getPdfCsvData = async (dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(API.GET_ALL_CUSTOMERS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    getAllCustomer,
    deleteCustomer,
    getCustomer,
    // product,
    addCustomer,
    updateCustomer,
    deleteManyCustomer,
    BulkUpload,
    customer,
    loading,
    getPdfCsvData,
    pdfCsvData,
    downloadLoading,
    paginate,
  }
}
